import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const reportSlice = createSlice({
  name: "reportSlice",
  initialState: {
    loading: false,
    reportData: {},
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getReport: (state, action) => {
      state.reportData = action.payload;
    },
  },
});

export const { loading, getReport } = reportSlice.actions;

export const getReportFunc = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/all_stats`;
    const { data } = await axios.post(url,{}, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getReport(data));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export default reportSlice.reducer;
